<div class="medicamentos-container">
  <h2 class="titulo">Medicamentos a Reponer</h2>

  <app-medicamentos-filtro></app-medicamentos-filtro>
  <app-tabla-medicamentos></app-tabla-medicamentos>
  <app-acciones-reposicion></app-acciones-reposicion>

</div>
